(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-breeds"]) return;
  try {
    
  var $breedChooser = $('.collection-breeds__breed-chooser')

  $breedChooser.each(function (i, element) {
    var $chooser = $(element)
    var $select = $(element).find('select')

    $select.on('change', function () {
      window.location.href = $(this).val()
    })

    $select.on('chosen:ready', function () {
      $chooser.find('.chosen-single').append("<i class='chevron down'></i>")
    })
    
    $chooser.find('.chosen-container').on('touchstart', function (e) {
      e.stopPropagation()
      e.preventDefault()
      
      $(this).trigger('mousedown')
    })

    $select.each(function (i, element) {
      $(element).chosen()
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"]) return;
  try {
    
  const $section = $('#shopify-section-featured-collections')
  const $categoryTitlesScrollArea = $section.find('.featured-collections__titles')
  const $categoryTitles = $section.find('.featured-collections__title[data-handle]')
  const $categories = $section.find('.featured-collections__items[data-handle]')
  const $leftArrow = $section.find('.icon-caret-left')
  const $rightArrow = $section.find('.icon-caret-right')

  $categoryTitles.on('click', evt => {
    const $el = $(evt.target)
    const $selectedCategory = $categories.filter(`[data-handle="${$el.data('handle')}"]`)

    $categoryTitles.removeClass('is-open')
    $categories.removeClass('is-open')

    $el.addClass('is-open')
    $selectedCategory.addClass('is-open')

    if ($selectedCategory.index() === 1) {
      $leftArrow.addClass('featured-collections__hidden')
    } else {
      $leftArrow.removeClass('featured-collections__hidden')
    }

    if ($selectedCategory.index() === $categoryTitles.length) {
      $rightArrow.addClass('featured-collections__hidden')
    } else {
      $rightArrow.removeClass('featured-collections__hidden')
    }
  })

  $leftArrow.on('click', () => {
    $selectedCategory = $categoryTitles.filter('.is-open')
    $prevCategory = $selectedCategory.prev()

    if ($prevCategory.length) {
      $categoryTitlesScrollArea.scrollLeft(0)
      $prevCategory.click()
    }
  })

  $rightArrow.on('click', () => {
    $selectedCategory = $categoryTitles.filter('.is-open')
    $nextCategory = $selectedCategory.next()

    if ($nextCategory.length) {
      $categoryTitlesScrollArea.scrollLeft(9999)
      $nextCategory.click()
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  let form = document.querySelector('.footer__newsletter')
  let formUrl = form.getAttribute('data-url')

  const onSubmit = evt => {
    evt.preventDefault();

    form = document.querySelector('.footer__newsletter')
    formUrl = form.getAttribute('data-url')
    const email = form.querySelector('input[type="email"]').value
    
    $.ajax({
      url: formUrl,
      type: 'post',
      dataType: 'json',
      data: { email: email }
    })

    form.classList.add('submitted')
  }

  form.addEventListener('submit', onSubmit)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.addEventListener('submit', onSubmit)
      }
    })

    document.addEventListener('shopify:section:unload', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.removeEventListener('submit', onSubmit)
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  const selector = '.hero__swiper'
  let swiperEl = document.querySelector(selector)
  let dotsColors = JSON.parse(swiperEl.getAttribute('data-dots-colors'))

  const config = {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: (swiper) => {
        swiperEl.style.setProperty('--dotsColor', dotsColors[swiper.activeIndex])
      },
      slideChange: (swiper) => {
        swiperEl.style.setProperty('--dotsColor', dotsColors[swiper.activeIndex])
      }
    },
  }

  let swiper = new Swiper(selector, config)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', evt => {
      swiperEl = document.querySelector(selector)
      dotsColors = JSON.parse(swiperEl.getAttribute('data-dots-colors'))

      // If rerender is caused by a change/navigation to a block, rerender will
      // be handled in the shopify:block:select event
      if (evt.detail.sectionId === 'hero' && !evt.detail.blockId) {
        swiper = new Swiper(selector, config)
      }
    })

    document.addEventListener('shopify:section:unload', evt => {
      if (evt.detail.sectionId === 'hero') {
        swiper.destroy()
      }
    })

    document.addEventListener('shopify:block:select', evt => {
      const index = [...evt.target.parentNode.children].indexOf(evt.target)

      if (event.detail.load) {
        swiper = new Swiper(selector, {
          initialSlide: index,
          ...config
        })
      } else {
        swiper.slideTo(index)
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
